module.exports = __webpack_public_path__ + "static/logo-17582e7993a5a8b0af51f94a93682367.png";